import { useQuery } from "@tanstack/react-query";
import { fetchGoogleLocations } from "../../api/bReviewsApi";

export const useGetGoogleLocations = (organisationId, enabled = true) => {
  return useQuery({
    queryKey: ["google-locations", organisationId],
    queryFn: () => fetchGoogleLocations(organisationId),
    enabled: !!organisationId && enabled,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });
};
